<template>
  <section class="flex h-full min-w-0 flex-col">
    <header class="flex-none border-b border-gray-200 bg-gray-50 px-5 py-3">
      <div class="flex flex-wrap items-center gap-2">
        <span class="text-xs font-bold uppercase text-gray-500">Version {{ side.toUpperCase() }}</span>
        <span class="rounded border border-blue-200 bg-blue-50 px-2 py-1 text-xs font-bold text-blue-700">{{ section.amendmentKey }}</span>
        <span v-if="section.isCurrent" class="text-xs font-bold uppercase text-green-700">Current</span>
      </div>
      <h2 class="mt-1 text-sm font-bold leading-tight text-gray-800">{{ section.title }}</h2>
    </header>
    <div v-if="side === 'b'" class="flex flex-none gap-3 border-b border-gray-100 bg-white px-5 py-2 text-xs font-semibold">
      <span class="text-green-700">Added</span>
      <span class="text-yellow-700">Changed</span>
      <span class="text-red-600">Removed</span>
    </div>
    <div class="min-h-0 flex-1 overflow-y-auto px-5 py-4">
      <ParagraphBlock
        v-for="(paragraph, index) in section.paragraphs"
        :key="paragraph.paragraphId || index"
        :paragraph="paragraph"
        :assets="assetPlacement.paragraphAssets[index]"
        :diff-status="diffStatus(paragraph, index)"
      />
      <div v-if="assetPlacement.unreferencedAssets.length" class="mt-8 border-t border-gray-200 pt-4">
        <p class="mb-2 text-xs font-bold uppercase text-gray-400">Unreferenced assets</p>
        <AssetCard v-for="asset in assetPlacement.unreferencedAssets" :key="asset.assetId" :asset="asset" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import AssetCard from "./AssetCard.vue";
import ParagraphBlock from "./ParagraphBlock.vue";
import { assignSectionAssets } from "../utils/sectionAssets.js";

const props = defineProps({
  section: { type: Object, required: true },
  diff: { type: Object, default: null },
  side: { type: String, default: "a" },
});
const assetPlacement = computed(() => assignSectionAssets(props.section.paragraphs, props.section.assets));
function diffStatus(paragraph, index) {
  return props.diff?.[props.side]?.[paragraph.paragraphId || String(index)];
}
</script>
